import { SLICER_KEYS } from 'types/services';
import { createSlice } from '@reduxjs/toolkit';
import type { Tab, TemplateSection } from 'types/helios/templateForms/templateForms';
import { heliosFormsService } from 'store/services/helios/forms';

import { addNewSection, newSection } from './reducers/addNewSection';
import { renameSection } from './reducers/renameSection';
import { removeSection } from './reducers/removeSection';
import { removeSectionItem } from './reducers/removeSectionItem';
import { resetSection } from './reducers/resetSection';
import { updateSectionItem } from './reducers/updateSectionItem';
import { setSectionGrid } from './reducers/setSectionGrid';
import { setSectionConditions } from './reducers/setSectionConditions';
import { setSectionItemConditions } from './reducers/setSectionItemConditions';
import { reorderSectionItem } from './reducers/reorderSectionItem';
import { resizeSectionItem } from './reducers/resizeSectionItem';
import { reorderSections } from './reducers/reorderSections';
import { moveSectionToTab } from './reducers/moveSectionToTab';
import { copyWebToMobile } from './reducers/copyWebToMobile';
import { setSectionCollapseConditions } from './reducers/setSectionCollapseConditions';
import { renameSubTab } from './reducers/renameSubTab';
import { removeSubTab } from './reducers/removeSubTab';
import { removeTab } from './reducers/removeTab';
import { reorderSubTab } from './reducers/reorderSubTab';
import { addTab } from './reducers/addTab';
import { renameTab } from './reducers/renameTab';
import { reorderTab } from './reducers/reorderTab';
import { reassignSectionsToTab } from './reducers/reassignSectionsToTab';
import { generateGridPlaceholders } from 'utils/section/gridUtils';
import { initialItem } from './reducers/addNewSection';

export interface TemplateFormsState {
  Web: { sections: TemplateSection[]; tabs: Tab[] };
  Mobile: { sections: TemplateSection[]; tabs: Tab[] };
}

const initialState: TemplateFormsState = {
  Web: { sections: [], tabs: [] },
  Mobile: { sections: [], tabs: [] },
};

export const templateFormsState = createSlice({
  name: SLICER_KEYS.TEMPLATE_FORMS,
  initialState,
  reducers: {
    addNewSection,
    renameSection,
    removeSection,
    removeSectionItem,
    resetSection,
    updateSectionItem,
    setSectionGrid,
    setSectionConditions,
    setSectionItemConditions,
    reorderSectionItem,
    resizeSectionItem,
    reorderSections,
    moveSectionToTab,
    copyWebToMobile,
    setSectionCollapseConditions,
    renameSubTab,
    removeSubTab,
    removeTab,
    reorderSubTab,
    addTab,
    renameTab,
    reorderTab,
    reassignSectionsToTab,
  },
  extraReducers(builder) {
    builder.addMatcher(heliosFormsService.endpoints.getFormLayout.matchFulfilled, (state, { payload }) => {
      state[payload.layoutType] = {
        sections:
          payload.sections.length === 0
            ? [newSection]
            : payload.sections.map((section) => ({
                ...section,
                items: generateGridPlaceholders(
                  section.items.filter((item) => item.itemGuid),
                  section.sizeX,
                  section.sizeY,
                  initialItem,
                  (section.subTabs ?? []).map((st) => st.id)
                ),
              })),
        tabs: payload.tabs ?? [],
      };
    });
  },
});

export const templateFormsActions = templateFormsState.actions;
